import { FormControl, FormHelperText, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

export default function CluppTextArea({
  state,
  setState,
  field,
  multiline = false,
  label,
  variant = "standard",
  autoFocus = false,
  validationFunction = null,
}) {
  const [error, setError] = useState({
    haveAnError: false,
    errorMessage: "",
  });
  const textAreaRef = useRef(null);
  const handleChange = async (e) => {
    setState((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
    if (validationFunction) {
      const validationResult = await validationFunction(e.target.value);
      setError(validationResult);
    }
  };

  useEffect(() => {
    if (autoFocus && textAreaRef.current) {
      textAreaRef.current.querySelector("textarea").focus();
    }
  }, [autoFocus]);

  return (
    <FormControl
      variant={variant}
      sx={{
        width: "100%",
      }}
    >
      <TextField
        ref={autoFocus ? textAreaRef : null}
        label={label}
        multiline={multiline}
        value={state[field]}
        maxRows={4}
        variant={variant}
        onChange={handleChange}
        error={error.haveAnError}
      />
      {error?.errorMessage && (
        <FormHelperText id="component-error-text" sx={{ color: "#FE7676" }}>
          {error.errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
}
